import React, { createContext, useContext, useState } from 'react';

const FavsContext = createContext();

export const FavsProvider = ({ children }) => {
    const [favs, setFavs] = useState(0);

    return (
        <FavsContext.Provider value={{ favs, setFavs }}>
            {children}
        </FavsContext.Provider>
    );
};

export const useFavs = () => useContext(FavsContext);
